import { createGlobalStyle } from 'styled-components';
import { Theme } from './theme';

export const GlobalStyle = createGlobalStyle<{ theme: Theme }>`
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }
    
    html, body {
        height: 100%;
    }
    
    body {
        font-family: ${({ theme }) => theme.fonts.primary};
        background-color: ${({ theme }) => theme.colors.backgroundDark};
        color: ${({ theme }) => theme.colors.text};
        line-height: 1.5;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    
    a {
        color: ${({ theme }) => theme.colors.primary};
        text-decoration: none;
        
        &:hover {
            text-decoration: underline;
        }
    }
    
    button, input, select, textarea {
        font-family: inherit;
    }
    
    code {
        font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
    }
    
    #root {
        min-height: 100%;
        display: flex;
        flex-direction: column;
    }
`;
